export enum DefaultDateModeEnum {
    today = 'today',
    nextDay = 'nextDay',
    previousDay = 'previousDay',
    nextBusinessDay = 'nextBusinessDay',
    previousBusinessDay = 'previousBusinessDay'
}

export enum StartDateModeEnum {
    beginningOfMonth = 'beginningOfMonth',
    beginningOfYear = 'beginningOfYear'
}

export enum EndDateModeEnum {
    endOfYear = 'endOfYear',
    oneYear = 'oneYear'
}

export enum CommonDateModeEnum {
    calendarDate = 'calendarDate',
    custom = 'custom',
    none = 'none'
}

export type DateModeEnum = DefaultDateModeEnum | StartDateModeEnum | EndDateModeEnum | CommonDateModeEnum;

export interface DatePreset {
    mode: DateModeEnum;
    label?: string;
    value: string;
}
